import React from 'react';
import menuShape from "../assets/img/course/menu-shape-1.png";

const PdExam = () => {
  return (
    <div>
      <div class="modal-body">
        <div class="container">
            <div class="row text-center">
                <div class="col-lg-12 col-12">
                    <p class="talk_title">Appear for</p>
                    <h3 class="pb-2">India's 1<sup>st</sup> AI Complied Entrance Exam</h3>
                    <p class="pdcet">PDCET</p>
                    <p>A Company to Success</p>
                      <p class="know">Know Your Score</p>
                    <a href="https://exam.padhaidekho.com/register" target="_blank" class="theme-btn mt-30">Register Now<i class="fas fa-arrow-right-long"></i></a>
                </div>
            </div>
        </div>
    </div>
    <img src={menuShape} />
      {/* Your exam content */}
    </div>
  );
};

export default PdExam;
